import type { Cashflow } from './cashflowWire'
import { andList } from './cashflowRules'
import './cashflow.css'

/**
 * Currencies the server could not convert (`fx.unconverted`), named and never
 * summed or shown as amounts: the totals leave them out, and the page says so.
 * Not premium data, so a free user sees it too.
 */
export function UnconvertedNote({ unconverted }: { unconverted: Cashflow['unconverted'] }) {
  if (unconverted.length === 0) return null
  const codes = andList(unconverted.map((u) => u.currency))
  return <p className="cf-note">Some transactions in {codes} couldn't be converted and aren't included.</p>
}
